import React, {Component} from "react";

import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
    InputGroup,
    InputGroupAddon
} from "reactstrap";

import Registry from "../Utils/Registry";
import PasswordResetForm from "../components/Account/ResetPassForm";


class ResetPass extends Component {
    constructor(props){
        super(props);

        this.state = {
            loading: false,
            success: false,
            email: "",
            error: false,
            token: null
        };

        this.api = Registry.registered("api");
    }

    componentDidMount(){
        if(this.props.match.params.token)
            this.setState({token: this.props.match.params.token});
    }

    send = () => {
        if (this.state.email === "")
            this.setState({ loading: false, success: false, error: "Merci de renseigner votre email" });
        else {
            this.setState({ loading: true, success: false, error: false });

            this.api.post("/customers/password/reset/request", {email: this.state.email})
                .then(_ => {
                    this.setState({
                        success: true, 
                        loading: false
                    });
                })
                .catch(error => {
                    let msg = "Une erreur est survenue, merci de rééssayer d'ici quelques minutes. Si le problème persiste n'hesitez pas à nous contacter";
                    if(error.hasOwnProperty("subcode")) {
                        switch (error.subcode) {
                            case "POSTCustomersCustomerResourceNotFound":
                                msg = "l'email entré ne correspond à aucun utilisateur enregistré";
                                break;
                            case 'POSTCustomersInvalidEmail':
                                msg = "l'email entré est invalide";
                                break;
                            case 'POSTCustomersNotActivatedAccount':
                                msg = "Votre compte n'est pas encore activé. Vous avez reçu un email avec un lien vous permettant d'activer votre compte.";
                            default:
                                break;
                        }
                    }

                    this.setState({ error: msg, loading: false });
                });
        }

    };


    render() {
        return (
            <div className="app align-items-center bg-blue_dark">

                <div className="wp-100 text-center display-block marg-t-50 marg-b-0">
                    <img src="../img/TankYou-v2-white.png" className="img-fluid _w-200" />
                </div>

                <Container className="display-block">
                    <Row className="justify-content-center">
                        <h1 className="ty-title-blue_dark ty-title-after-blue text-white ">R&eacute;initialisation du mot de passe</h1>
                    </Row>

                    {
                        this.state.token ?
                            <PasswordResetForm token={this.state.token} />
                            :
                            <Row className="justify-content-center">
                                <Col md="6">
                                    <Card className="p-4 border-rad-5">
                                        {
                                            !this.state.loading ?
                                                <CardBody className="card-body">
                                                    <Row>
                                                        <Col xs="12" className="center marg-b-20">
                                                            Entrez l'adresse email associ&eacute;e &agrave; votre compte Tankyou et nous vous enverrons un email 
                                                            avec les instructions pour changer votre mot de passe
                                                        </Col>
                                                    </Row>
                                                    {
                                                        this.state.error !== false ?
                                                            <Row>
                                                                <Col xs="12" className="center marg-b-20 red">
                                                                    { this.state.error }
                                                                </Col>
                                                            </Row>
                                                            : null
                                                    }
                                                    {
                                                        this.state.success !== false ?
                                                            <Row>
                                                                <Col xs="12" className="center marg-b-20 green">
                                                                    Un email vous a &eacute;t&eacute; envoy&eacute; avec un liens vous permettant de r&eacute;initialiser votre mot de passe
                                                                </Col>
                                                            </Row>
                                                            : null
                                                    }
                                                    <InputGroup className="mb-4">
                                                        <InputGroupAddon><i className="icon-user" /></InputGroupAddon>
                                                        <Input type="email" placeholder="Email ..." value={this.state.email} onChange={e => {this.setState({email: e.target.value })}} />
                                                    </InputGroup>
                                                    <Row>
                                                        <Col xs="12" className="center">
                                                            <Button className="uppercase px-4" color="primary" onClick={this.send}>
                                                                Envoyer
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                                :
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" className="center">
                                                            <i className="fa fa-spinner fa-spin fa-3x"></i><br /><br />
                                                            Chargement ...
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                        }
                                    </Card>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        );
    }
}

export default ResetPass;



// WEBPACK FOOTER //
// ./src/pages/ResetPass.js